
.headerToggleContainer {
  background-color: var(--static-background-weak);
  border-radius: 0.375rem;
  margin-bottom: 2rem;
}

.headerToggleButton {
  flex: 1 1 0;
  font: inherit;
  background: none;
  border: none;
  color: var(--static-text-strong);
  margin: 0.25rem;
  border-radius: 0.375rem;
}

.alert {
  margin: 20px;
}

.allBoxesCheckedLabel {
  display: flex;
  gap: 1ch;
  padding: 1rem;
  font: inherit;
}

.truncateText {
  min-width: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 30rem;
  display: inline-block;
}

.headerToggleButton {
  cursor: pointer;
}

.headerToggleButtonSelected {
  background-color: var(--static-background-standard);
  box-shadow: 0.125rem 0.125rem 0.125rem var(--static-divider-standard);
}

.bulkAssignModal {
  min-height: 50vh;
}

.quantityAssignedRow {
  padding: 1rem;
}

.productImage {
  flex-shrink: 0;
  margin-right: 1ch;
}

.productHeader {
  padding: 1rem 0.5rem;
}

.splitEvenlyInput {
  flex: 1 1 max-content;
  -moz-appearance: textfield;
}

.splitEvenlyInput::-webkit-inner-spin-button,.splitEvenlyInput::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.boxRow {
  padding: 1rem;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
}

.boxRow:hover {
  border-top: 1px solid var(--static-divider-standard);
  border-bottom: 1px solid var(--static-divider-standard);
  color: var(--static-text-strong);
}

.splitEvenlyContainer {
  padding: 1rem;
}

.createNewBoxButton {
  margin: 1rem;
}

.bulkAssignModal {
  position: relative;
  overflow-y: auto;
  max-height: 60vh;
}

.modalFooter {
  bottom: 0;
  position: sticky;
}
.modalHeader {
  top: 0;
  position: sticky;
}
